<template>
    <div class="graph">
        <h2 class="graph__title" v-html="$t('BarGraph.completions_per_month')"></h2>
        <p class="graph__timerange-subtitle">{{ graphDateRangeLabel }}</p>
        <BarGraph :chartData="chartData" :class="['graph__chart', { graph__empty: isChartDataEmpty}]"
                  @on-click-in-graph-element="goToCompletedCourses" />
        <p class="graph__subtitle" v-html="$t('BarGraph.study_summary')"></p>
        <p class="graph__label">
            <span v-html="$t('BarGraph.completed_courses')"></span> 
            <span class="graph__data">{{ numberOfCompletedCoursesInYear }} {{ $t('BarGraph.items') }}</span>
        </p>
        <p class="graph__label">
            <span v-html="$t('BarGraph.courses_in_progress')"></span> 
            <span class="graph__data"> {{ numberOfUnfinishedCoursesInYear }} {{ $t('BarGraph.items') }}</span>
        </p>
        <p class="graph__label">
            <span v-html="$t('BarGraph.watchlists')"></span> 
            <span class="graph__data">{{ watchLists.length }} {{ $t('BarGraph.items') }}</span>
        </p>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import BarGraph from 'components/user/graphs/BarGraph'
    import dateHelper from 'components/shared/mixins/dateHelper'
    import barHelper from 'helpers/barHelper'

    export default {
        props: {
            completedCourses: Array,
            unfinishedCourses: Array
        },
        mixins: [dateHelper, barHelper],
        components: {
            BarGraph
        },
        computed: {
            ...mapGetters({
                watchLists: 'Watchlists/getWatchLists',
                getCertificateForCourse: 'CompletedCourses/getCertificateForCourse',
                graphYear: 'User/getGraphYear'
            }),
            selectedYear () {
                return this.graphYear === 'last-12-months' ? null : this.graphYear
            },
            chartData () {
                let completed = this.completedCourses
                    .map(course => course.certificate?.certificationDate)
                    .map((date) => date.substr(0, 7))

                let labels = this.getYearlyArrayOfDatesInFormat(this.selectedYear ? 'Y-MM' : 'MMMM', this.selectedYear)
                let colors = []
                let monthData = this.setCompletedCoursesIntoMonths(completed)
                const color = this.colorGenerator()
                for (let i = 0; i < 12; i++) {
                    colors.push(color)
                }
                return {
                    labels: labels,
                    datasets: [
                        {
                            label: this.$t('BarGraph.completed_courses'),
                            backgroundColor: colors,
                            data: monthData
                        }
                    ]
                }
            },
            isChartDataEmpty () {
                return this.chartData.datasets[0].data.length === 0
            }
        },
        methods: {
            setCompletedCoursesIntoMonths (completed) {
                let monthsData = []

                if (completed.length === 0) {
                    return monthsData
                }

                this.getYearlyArrayOfDatesInFormat('Y-MM', this.selectedYear).map((date, index) => {
                    monthsData[index] = completed.filter(el => el === date).length
                })
                return monthsData
            },
            goToCompletedCourses (data) {
                if (!data) {
                    return
                }

                let labelIndex = this.chartData.labels.findIndex(el => el === data)
                let month = this.getYearlyArrayOfDatesInFormat('M', this.selectedYear)[labelIndex]
                let year = this.getYearlyArrayOfDatesInFormat('Y', this.selectedYear)[labelIndex]
                let numberOfDaysInMonth = this.getDaysInMonth(month, year)
                let startDate = new Date(year, month - 1, 1)
                let endDate = new Date(year, month - 1, numberOfDaysInMonth)

                this.$router.push({ name: 'user-completed', params: { startDate, endDate } })
            },
            colorGenerator () {
                let r = function () { return Math.floor(Math.random() * 256) }
                return 'rgba(' + r() + ',' + r() + ',' + r() + ',0.2)'
            }
        }
    }
</script>

<style lang="scss" scoped>
@include summary_graph;
</style>
